import React, { useContext } from "react";

import { useHistory } from "react-router-dom";

import { useQuery } from "react-apollo";
import { ALL_COMPANYS_QUERY } from "../../../graphql/Company/Companys.graphql";

import { AddCompanyInfoForm } from "../../../components/Company";

import { ModalContext } from "../../../components/ModalProvider";

import DataTable from "../../../components/DataTable";

import { COMPANY_COLUMNS } from "./columns";

import PageHeader from "../../../components/PageHeader";
import { ourToast as toast } from "../../../utils";

const CompaniesPage = () => {
  const history = useHistory();
  const { data, loading, error } = useQuery(ALL_COMPANYS_QUERY);
  const { setModalOpen } = useContext(ModalContext);

  if (loading || !data?.Companys) return <p>Loading</p>;
  if (error) {
    toast.error("Error getting Companies.");
    return null;
  }
  return (
    <React.Fragment>
      <PageHeader
        subheader
        columns={COMPANY_COLUMNS}
        name="Companys"
        query={ALL_COMPANYS_QUERY}
        title="Company"
        onAddClick={() =>
          setModalOpen(
            true,
            <AddCompanyInfoForm setModalOpen={() => setModalOpen(false, "")} />
          )
        }
      />
      <DataTable
        columns={COMPANY_COLUMNS}
        dataQuery={ALL_COMPANYS_QUERY}
        name="Company"
        onRowClick={({ RecId }) => {
          history.push(`/admin/company/${RecId}/details`);
        }}
      />
    </React.Fragment>
  );
};

export default CompaniesPage;
